import { useRuntimeConfig } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

type VertexAiSearchResult =
  | { enabled: false; hostUrl: undefined }
  | { enabled: true; hostUrl: string }

export function useVertexAiSearch(
  feature: string | undefined,
): VertexAiSearchResult {
  if (!feature) {
    return { enabled: false, hostUrl: undefined }
  }

  const experiments = useExperiments()

  if (experiments['experiment.vertexAiSearch'] !== 'withVertexAiSearch') {
    return { enabled: false, hostUrl: undefined }
  }

  const { market } = useMarketplace()
  const http2Config = useRuntimeConfig().public.http2

  const baseUrl = import.meta.server
    ? http2Config.baseUrlServer
    : (http2Config.baseUrlClient || window.location.origin).replace(
        '{market.domain}',
        market.domain,
      )

  if (!baseUrl) {
    return { enabled: false, hostUrl: undefined }
  }

  const hostUrl = `${baseUrl.replace('https://', '')}/api/search-vertex-ai`

  return { enabled: true, hostUrl }
}
